/**
 * BookOnBehalf — FSR books a walk-in customer. Reuses the public BookingWizard
 * so the FSR sees the same screens the customer would. A small context banner
 * reminds the FSR who is the actual booker (them) vs who the booking is for.
 */

import { BookingWizard } from './booking/BookingWizard';
import { Pill } from '@/components/primitives';
import { useAuth } from '@/contexts/AuthContext';

export function BookOnBehalf(): JSX.Element {
  const { user } = useAuth();
  return (
    <div className="module-page">
      <div
        style={{
          padding: 'var(--sp-6) var(--sp-8)',
          background: 'var(--warn-bg)',
          color: 'var(--warn-text)',
          border: '1px solid var(--pcb-amber-text)',
          borderRadius: 'var(--r-md)',
          marginBottom: 'var(--sp-7)',
          fontSize: 13,
          display: 'flex',
          gap: 'var(--sp-6)',
          alignItems: 'center',
        }}
        role="status"
      >
        <Pill variant="warn">Book on behalf</Pill>
        <span>
          You ({user?.displayName ?? 'Officer'}) are booking on behalf of a walk-in customer.
          The confirmation email goes to the customer's address you enter on Step 5, not yours.
        </span>
      </div>
      <BookingWizard />
    </div>
  );
}
